import { ApiUtil as api } from "@/utils/api.util.js";
import serialize from "@/helpers/serialize";

export class VettedStatementRelationshipService {
  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/vetted-order-activity-relationships/";

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams).then(
      data => {
        return data;
      },
      error => {
        throw error;
      }
    );
  }

  static delete(queryParams = {}) {
    return api
      .delete(this.URL + this.RESOURCE + `?${serialize(queryParams)}`)
      .then(
        data => {
          return data;
        },
        error => {
          throw error;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/services/vettedStatementRelationship.service.js